"use client"

import { use, type ReactNode } from "react"

const gates = new Map<string, Promise<void>>()

const gateFor = (query: string): Promise<void> => {
  const cached = gates.get(query)
  if (cached) return cached
  const media = window.matchMedia(query)
  let open: () => void = () => {}
  const gate = new Promise<void>((resolve) => {
    open = resolve
  })
  if (media.matches) {
    void Object.assign(gate, { status: "fulfilled", value: undefined })
  } else {
    const onChange = () => {
      if (!media.matches) return
      media.removeEventListener("change", onChange)
      open()
    }
    media.addEventListener("change", onChange)
  }
  gates.set(query, gate)
  return gate
}

interface HydrateAtViewportProps {
  query: string
  children: ReactNode
}

export const HydrateAtViewport = ({ query, children }: HydrateAtViewportProps) => {
  if (typeof window !== "undefined" && typeof window.matchMedia === "function") use(gateFor(query))
  return <>{children}</>
}
